export default __webpack_public_path__ + "static/media/reverse_fly_end.8c525e09.svg";